export default __webpack_public_path__ + "static/media/carvana-smiley-car-with-sparkles.a49a7af5.svg";